(function () {

    async function initProductVideoBySku() {

        const container = document.getElementById("pm-product-video");

        if (!container) return;

        const sku = container.dataset.sku;

        try {

            const response = await fetch(window.pmProductVideoDataUrl);
            const data = await response.json();

            console.log("Video SKU:", sku);
            console.log("Video JSON:", data);

            const video = data[sku];

            if (!video || !video.youtube_id) {
                console.log("Este producto no tiene video.");
                return;
            }

            const iframe = container.querySelector(".pm-product-video__frame");

            if (!iframe) {
                console.error("No se encontró el iframe del video.");
                return;
            }

            iframe.src =
                "https://www.youtube.com/embed/" +
                video.youtube_id +
                "?rel=0&modestbranding=1";

            container.style.display = "block";

        } catch (error) {

            console.error("Error cargando video:", error);

        }

    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initProductVideoBySku);
    } else {
        initProductVideoBySku();
    }

})();